import * as types from 'constants/interview';
import {
  AjaxByToken,
  cancelRequestByKey,
  AjaxByGetByResumeClient
} from 'utils/ajax';
import {
  message,
  notification
} from 'antd';
import axios from 'axios'
let defaultData = {};
// 获取面试官table的数据列表
const INTERVIEW_TABLE_DATA = {
  type: types.INTERVIEW_TABLE_DATA
};
// 面试官的开始结束加载
const LOAD_TABLE_START = {
  type: types.LOAD_TABLE_START
};
const LOAD_TABLE_DONE = {
  type: types.LOAD_TABLE_DONE
};
// 显示面试官列表MODAL
const SHOW_INTERVIEW_MODAL = {
  type: types.SHOW_INTERVIEW_MODAL
};
// 隐藏面试官列表MODAL
const HIDE_INTERVIEW_MODAL = {
  type: types.HIDE_INTERVIEW_MODAL
};
// 获取面试官table的数据列表
const INTERVIEW_LIST_DATA = {
  type: types.INTERVIEW_LIST_DATA
};
// 获取面试官table列表
export const getinterviews = (skip, key) => (dispatch, getState) => {
  const uri = 'getinterviewers';
  cancelRequestByKey(uri);
  dispatch(LOAD_TABLE_START);
  AjaxByToken(uri, {
      head: {
        transcode: 'L0105',
      },
      data: {
        skip: skip ? skip : 0,
        count: 10,
        key
      }
    })
    .then(res => {
      dispatch(LOAD_TABLE_DONE);
      dispatch({
        ...INTERVIEW_TABLE_DATA,
        interviewData: res
      });
    }, err => {
      dispatch(LOAD_TABLE_DONE);
    });
}
// 点击设置取消面试官
export const cancelInterviews = (rid) => (dispatch, getState) => {
  const uri = 'updinterviewer';
  cancelRequestByKey(uri);
  dispatch(LOAD_TABLE_START);
  AjaxByToken(uri, {
      head: {
        transcode: 'L0106',
      },
      data: {
        rid,
        type: 2
      }
    })
    .then(res => {
      notification.success({
        message: '提示',
        description: '取消设置成功'

      });
      dispatch(LOAD_TABLE_DONE);

    }, err => {
      dispatch(LOAD_TABLE_DONE);
    });
}
// 点击增加面试官管理
export const addInterviews = (rid, index, list) => (dispatch, getState) => {
  let that = this
  const uri = 'updinterviewer';
  cancelRequestByKey(uri);
  dispatch(LOAD_TABLE_START);
  AjaxByToken(uri, {
      head: {
        transcode: 'L0106',
      },
      data: {
        rid,
        type: 1
      }
    })
    .then(res => {
      message.success('添加面试官成功！');
      list.forEach(item => {
        item.isInterviewer = list[index].isInterviewer = 1
      });

    }, err => {
      dispatch(LOAD_TABLE_DONE);
    });
}

//搜索功能的开发
export const searchInterview = (key) => (dispatch, getState) => {
  const uri = 'getinterviewers';
  cancelRequestByKey(uri);
  dispatch(LOAD_TABLE_START);
  AjaxByToken(uri, {
      head: {
        transcode: 'L0105',
      },
      data: {
        skip: 0,
        count: 10,
        key
      }
    })
    .then(res => {
      dispatch(LOAD_TABLE_DONE);
      dispatch({
        ...INTERVIEW_TABLE_DATA,
        interviewData: res
      });
    }, err => {
      dispatch(LOAD_TABLE_DONE);
    });
}
// 显示面试官成员MODAL
export const showInterviewModal = () => (dispatch, getState) => {
  dispatch(SHOW_INTERVIEW_MODAL);

}
// 隐藏面试官成员MODAL
export const hideInterviewModal = () => (dispatch, getState) => {
  dispatch(HIDE_INTERVIEW_MODAL);
}
// 获取面试官成员table-model的列表
export const getinterviewslist = (skip, key) => (dispatch, getState) => {
  const uri = 'emp/crewquery';
  cancelRequestByKey(uri);
  dispatch(LOAD_TABLE_START);
  AjaxByToken(uri, {
      head: {
        transcode: 'L0043',
      },
      data: {
        skip: skip ? skip + '' : '0',
        count: "10",
        sort: 'desc',
        key
      }
    })
    .then(res => {
      dispatch(LOAD_TABLE_DONE);
      dispatch({
        ...INTERVIEW_LIST_DATA,
        interviewList: res
      });
    }, err => {
      dispatch(LOAD_TABLE_DONE);
    });
}



// WEBPACK FOOTER //
// ./src/actions/interview.js